var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIllustrationTeaching = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 280 187"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 140,
  cy: 164,
  fill: "#FFC38B",
  rx: 140,
  ry: 23
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF362",
  d: "M60.292 160.236c14.066 1.077 26.83-15.817 28.508-37.734 1.68-21.917-8.363-40.557-22.429-41.634-14.066-1.078-26.83 15.816-28.508 37.733s8.363 40.557 22.43 41.635"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F19EB6",
  d: "M49.397 106.959c2.836-.2 5.023-1.955 4.884-3.918-.14-1.964-2.551-3.393-5.388-3.192s-5.023 1.955-4.884 3.918c.14 1.964 2.551 3.393 5.388 3.192M81.74 109.823c2.818.384 5.317-.886 5.583-2.837.265-1.95-1.803-3.842-4.62-4.226s-5.317.886-5.583 2.836 1.803 3.843 4.62 4.227"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M56.3 99.405a5.743 5.743 0 1 0 4.566-10.539 5.743 5.743 0 0 0-4.566 10.54M71.737 101.133a5.743 5.743 0 1 0 4.567-10.54 5.743 5.743 0 0 0-4.567 10.54"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#595857",
  d: "M57.794 98.789a3.168 3.168 0 1 0 2.52-5.814 3.168 3.168 0 0 0-2.52 5.814M73.598 100.547a3.169 3.169 0 1 0 2.519-5.816 3.169 3.169 0 0 0-2.519 5.816"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC38B",
  d: "M123.894 119.214a1 1 0 0 1 .97-.758h15.576c.459 0 .859.312.97.758l2.927 11.709a1 1 0 0 1-.97 1.243h-21.43a1 1 0 0 1-.97-1.243z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#9FDFE7",
  d: "M126.383 103.857a1 1 0 0 1 .984-.824h10.567a1 1 0 0 1 .984.824l2.091 11.71a1 1 0 0 1-.984 1.176h-14.749a1 1 0 0 1-.984-1.176z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF362",
  d: "M94.17 162.756a1 1 0 0 1-1.115-.688l-2.404-7.692a1 1 0 0 1 .525-1.201l10.677-5.089a1 1 0 0 1 1.385.604l3.402 10.884a1 1 0 0 1-.794 1.286z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#CDDC8D",
  d: "M121.41 134.573a1 1 0 0 1 .952-.694h20.575a1 1 0 0 1 .953.694l3.763 11.709a1 1 0 0 1-.952 1.306h-28.103a1 1 0 0 1-.952-1.306z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA3BD",
  d: "M117.747 150.012a1 1 0 0 1 .957-.709h27.895a1 1 0 0 1 .957.709l3.554 11.71a1 1 0 0 1-.957 1.29h-35.004a1 1 0 0 1-.956-1.29z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFC38B",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m89.293 71.907 4.154-9.489M95.023 77.328l7.699-6.929M98.181 84.516l10.103-2.283"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA3BD",
  d: "M252.824 91.398c-.794 34.672-4.499 74.184-40.485 74.184-35.987 0-44.204-67.878-44.204-67.878s-7.708-47.42 11.985-72.081c3.562-4.426 11.536-14.475 24.042-15.681a33.15 33.15 0 0 1 21.712 6.634c27.094 18.343 27.107 65.465 26.95 74.822"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF362",
  d: "M186.369 66.482c-.84-2.695-4.583-3.925-8.359-2.747-3.777 1.178-6.157 4.317-5.317 7.012.841 2.694 4.583 3.924 8.36 2.747s6.156-4.317 5.316-7.012M239.659 62.653c-.271-2.81-3.683-4.78-7.62-4.4s-6.91 2.966-6.639 5.776 3.683 4.78 7.62 4.4 6.91-2.966 6.639-5.776"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#595757",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M181.287 49.534a6.62 6.62 0 0 0 5.126 5.871 6.694 6.694 0 0 0 7.498-5.37M191.027 55.565l2.18 2.191M183.279 54.978l-2.885 2.261M186.423 56.886l-.3 2.835M208.922 49.926a7.66 7.66 0 0 0 7.417 4.293 7.66 7.66 0 0 0 6.762-5.265M220.458 54.777c-.137-.41 0 0 1.007 1.864M208.764 56.585l2.543-2.374M215.024 55.088l-.13 2.55"
})));
export default SvgIllustrationTeaching;